<template>
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.25 2.72344L11.25 3.875V1.5C11.25 0.948438 10.8016 0.5 10.25 0.5H1C0.448438 0.5 0 0.948438 0 1.5V10.5C0 11.0516 0.448438 11.5 1 11.5H10.25C10.8016 11.5 11.25 11.0516 11.25 10.5V8.125L13.25 9.27656C13.5828 9.46875 14 9.22812 14 8.84531V3.15625C14 2.77187 13.5828 2.53125 13.25 2.72344ZM4.125 3.5C4.125 3.56875 4.06875 3.625 4 3.625H2.25C2.18125 3.625 2.125 3.56875 2.125 3.5V2.75C2.125 2.68125 2.18125 2.625 2.25 2.625H4C4.06875 2.625 4.125 2.68125 4.125 2.75V3.5ZM12.875 7.76562L11.25 6.83125V5.17031L12.875 4.23438V7.76562Z"
      fill="#595959"
    />
  </svg>
</template>
